import {computed, signal} from "@preact/signals-react";
import {isEmpty} from "@ui-seeker/utils";

import { MENU_SIZE } from "../@constants"

// Signals
export const openMenu = signal(false)
// The user's last menu choice survives reloads; null means "never chosen", so the app config decides
export const MENU_SIZE_KEY = 'app_menu_size'
export const storedMenuSize = localStorage.getItem(MENU_SIZE_KEY)
export const menuSize = signal(storedMenuSize || MENU_SIZE.MINI)
export const appConfig = signal({})
export const appLang = signal('EN')
export const pageTitle = signal('')
export const pageSubtitle = signal('')
export const pageActions = signal(null)
export const pageTitleAction = signal(null)
export const pageFavFilters = signal(null)
export const pageToggles = signal(null)

// Computed
export const haveConfig = computed(() => !isEmpty(!appConfig.value))
export const spacing = computed(() => appConfig.value?.menu?.spacing || 0)
export const appFavicon = computed(() => appConfig.value?.favicon || '')
export const appIcon = computed(() => appConfig.value?.icon || '')
export const appLogo = computed(() => appConfig.value?.logo || appIcon.value)
export const appName = computed(() => appConfig.value?.appName)
export const appLogoutURL = computed(() => appConfig.value?.logoutURL || '')
export const showMenuIcon = computed(() => appConfig.value?.menu?.showAppIcon ?? true)
export const showUsername = computed(() => appConfig.value?.menu?.showUsername ?? true)
export const emptyImage = computed(() => appConfig.value?.emptyImage || null)
